<template>
  <div class="program-tv__filter">
    <div class="program-tv__filter-title">Dzień i godzina:</div>
    <div class="program-tv__filter-select">
      <v-select
        class="program-tv__filter-day"
        v-model="valueDate"
        placeholder="Wybierz"
        label="title"
        :options="optionsDate"
        :clearable="false"
        :readonly="false"
        :searchable="false"
        :max-height="240"
        @update:modelValue="changeRoute()"
      ></v-select>

      <v-select
         class="program-tv__filter-hour"
         :options="hoursArray"
         label="title"
         :clearable="false"
         :readonly="false"
         v-model="valueHour"
         placeholder="Wybierz"
         :searchable="false"
         @update:modelValue="selectTime()"
       >
       </v-select>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick } from 'vue'
import VueMultiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
import { useUtils } from '@/composables/useUtils'
import { useRouter } from 'vue-router'
import 'vue-select/dist/vue-select.css'

const props = defineProps({
  hoursArray: {
    type: Array,
    default: () => ([])
  }
})

const router = useRouter()

const valueDate = ref()
const optionsDate = ref([])
const valueHour = ref()

const emit = defineEmits(['updateDay', 'updateTime'])

const changeRoute = () => {
  emit('updateDay', valueDate.value.url)
  router.replace({ query: { date: valueDate.value.url } })
}

const selectTime = () => {
  emit('updateTime', valueHour.value)
}

const customLabelData = ({ day, dayName, date }) => {
  return `${day} ${dayName || ''} ${date}`
}

const initDateArray = () => {
  const days = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota']
  const shortDays = ['NIEDZ.', 'PN.', 'WT.', 'ŚR.', 'CZW.', 'PT.', 'SOB.']

  const start = new Date()
  let dayName = ''
  let shortDay = ''
  let day = ''
  let paramDate = ''
  let shortDate = ''
  let yearTemp = ''
  let monthTemp = ''
  let dayTemp = ''
  const numOfDays = 13

  start.setDate(start.getDate() - 1)

  for (let i = 0; i <= numOfDays; i++) {
    yearTemp = new Date(start).getFullYear().toString()
    monthTemp = (start.getMonth() + 1).toString()
    dayTemp = start.getDate().toString()

    if (dayTemp.length === 1) {
      dayTemp = `0${dayTemp}`
    }

    if (monthTemp.length === 1) {
      monthTemp = `0${monthTemp}`
    }

    dayName = days[start.getDay()]
    shortDay = shortDays[start.getDay()]
    shortDate = `${dayTemp}.${monthTemp}`

    if (i === 0) {
      day = 'Wczoraj'
    } else if (i === 1) {
      day = 'Dziś'
    } else if (i === 2) {
      day = 'Jutro'
    } else {
      day = ''
    }

    paramDate = `${yearTemp}-${monthTemp}-${dayTemp}`

    optionsDate.value.push({
      day,
      dayName,
      date: shortDate,
      title: `${day} ${dayName} ${shortDate}`,
      short: shortDay,
      url: paramDate
    })

    start.setDate(start.getDate() + 1)
  }
  valueDate.value = optionsDate.value[1]
}

const setValueDate = () => {
  const urlString = window.location.href
  const url = new URL(urlString)
  const paramDate = url.searchParams.get('date')

  setTimeout(() => {
    if (paramDate && optionsDate.value) {
      // let index =  this.optionsDate.findIndex(item => item.url === paramDate);
      let index = -1
      optionsDate.value.some((item, i) => {
        if (item.url === paramDate) {
          index = i
          return true
        }
        return false
      })
      valueDate.value = optionsDate.value[index]
    } else {
      valueDate.value = optionsDate.value[1]
    }
  }, 0)
}

onMounted(() => {
  setValueDate()
  initDateArray()
})

</script>

<style lang="scss">
@import '@/assets/scss/components/program/program-tv-filter.scss';
</style>
